<div class="modal fade ig-huellas-modal" id="huellasModal" tabindex="-1" aria-labelledby="huellasModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content ig-huellas-shell">
      <header class="ig-huellas-header">
        <div class="ig-huellas-heading">
          <span class="ig-huellas-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
          <div>
            <h2 id="huellasModalLabel">Huellas</h2>
            <p>Personas que han dejado su huella en iGuau</p>
          </div>
        </div>
        <button type="button" class="ig-huellas-close" data-bs-dismiss="modal" aria-label="Cerrar"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
      </header>

      <div class="modal-body ig-huellas-body" #scrollContainer (scroll)="onScroll($event)">
        <div *ngIf="load" class="ig-huellas-status" role="status">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Cargando huellas…
        </div>
        <div *ngIf="!load && error" class="ig-huellas-empty" role="alert">
          <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
          <strong>No se han podido cargar las huellas</strong>
          <span>{{ error }}</span>
          <button type="button" (click)="getHuellas()">Reintentar</button>
        </div>
        <ng-container *ngIf="!load && !error">
          <div *ngIf="huellas.length; else sinHuellas" class="ig-huellas-grid">
            <button type="button" class="ig-huella-card" *ngFor="let huella of huellas; trackBy: trackByHuella"
                    (click)="goPerfil(huella)" [disabled]="!huella.slug" [attr.aria-label]="'Visitar perfil de ' + nombre(huella)">
              <span class="ig-huella-avatars">
                <img [src]="huella.foto_principal_thumb || global.urlServer + 'img/default-user.png'" alt="" loading="lazy" class="ig-huella-persona">
                <img *ngIf="huella.foto_mascota_thumb" [src]="huella.foto_mascota_thumb" alt="" loading="lazy" class="ig-huella-mascota">
              </span>
              <span class="ig-huella-info">
                <span class="ig-huella-top"><strong>{{ nombre(huella) }}</strong><span class="ig-huella-new" *ngIf="huella.hu_vista === ''">Nueva</span></span>
                <span class="ig-huella-detail" *ngIf="detalle(huella)">{{ detalle(huella) }}</span>
                <span class="ig-huella-location" *ngIf="huella.ciudad"><i class="fa-solid fa-location-dot" aria-hidden="true"></i> {{ huella.ciudad }}</span>
                <span class="ig-huella-date"><i class="fa-regular fa-clock" aria-hidden="true"></i> {{ huella.hu_fechahora | cuandoFechas }}</span>
              </span>
              <i class="fa-solid fa-chevron-right ig-huella-arrow" aria-hidden="true"></i>
            </button>
          </div>
          <ng-template #sinHuellas>
            <div class="ig-huellas-empty">
              <span class="ig-huellas-empty-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
              <strong>Aún no hay huellas</strong>
              <span>¡Comparte momentos con tu mascota y conecta con la comunidad!</span>
            </div>
          </ng-template>
          <div *ngIf="loadingMore" class="ig-huellas-more" role="status"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Cargando más…</div>
        </ng-container>
      </div>
      <footer class="ig-huellas-footer">
        <span *ngIf="huellas.length" class="ig-huellas-count">{{ huellas.length }} {{ huellas.length === 1 ? 'huella mostrada' : 'huellas mostradas' }}</span>
        <button type="button" class="ig-huellas-dismiss" data-bs-dismiss="modal">Cerrar</button>
      </footer>
    </div>
  </div>
</div>
